export async function getSoundForAudioOutputCheck(): Promise<string> {
    const sound = await import('./sound-check');
    return sound.default;
}
